/**
 * Save a PDF the API sent as base64.
 *
 * HQ-API returns PDFs inside a JSON envelope rather than as a file response, so the browser has
 * to reassemble one. Written twice before this file existed, once for the subscription invoice
 * and once for the assistant's reports, which is one copy more than a sequence with a
 * `revokeObjectURL` at the end of it should have.
 *
 * The anchor has to be in the document for the click to count in Firefox, which is why it is
 * appended and removed rather than clicked where it stands.
 */
export function downloadBase64Pdf(base64: string, filename: string): void {
    const binary: string = atob(base64);
    // The buffer is allocated first and handed to Blob directly. Passing the Uint8Array view
    // instead is the obvious way round and does not typecheck: a view's buffer is an
    // ArrayBufferLike, which BlobPart will not take.
    const buffer: ArrayBuffer = new ArrayBuffer(binary.length);
    const bytes: Uint8Array = new Uint8Array(buffer);
    for (let index: number = 0; index < binary.length; index++) {
        bytes[index] = binary.charCodeAt(index);
    }

    const blob: Blob = new Blob([buffer], { type: 'application/pdf' });
    const blobUrl: string = window.URL.createObjectURL(blob);
    const link: HTMLAnchorElement = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
}
